import { cx } from "class-variance-authority";
import { MenuTrigger as AriaMenuTrigger } from "react-aria-components";
import useMeasure from "react-use-measure";

import type { MenuProps } from "@/components/ui/Menu/Menu";
import { MenuPopover } from "@/components/ui/Menu/MenuPopover";

export const MenuDesktop = ({ trigger, items, triggerClassName }: MenuProps) => {
  const [triggerRef, { width }] = useMeasure();
  return (
    <AriaMenuTrigger>
      <div
        ref={triggerRef}
        className={cx("w-auto flex-auto", triggerClassName)}
      >
        {trigger}
      </div>
      <MenuPopover
        offset={0}
        className="pt-2"
        items={items}
        style={{ width: width || undefined }}
      />
    </AriaMenuTrigger>
  );
};
